import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export function checkPaymentsExist(programTypeID, programPaymentTypeID, partnerID, periodID) {
    return http.get(API_PATHS.checkFacilityPaymentsExist, { params: { programTypeID, programPaymentTypeID, partnerID, periodID } });
}

export function generate(generateParams) {
    return http.post(API_PATHS.generateFacilityPayments, generateParams);
};